import React from "react";
import {
  Grid,
  Typography,
  Box,
  Paper,
  createTheme,
  ThemeProvider,
} from "@mui/material";
import {
  LocalShipping,
  AllInclusive,
  TipsAndUpdates,
  GppGood,
  HeadsetMic,
} from "@mui/icons-material";
import LocalGasStationIcon from "@mui/icons-material/LocalGasStation";
import { useTranslation } from "react-i18next";

const theme = createTheme({
  palette: {
    primary: {
      main: "#1C2541",
    },
    secondary: {
      main: "#EE8013",
    },
    background: {
      default: "#F4F4F4",
    },
  },
});

const Features = () => {
  const { t } = useTranslation();

  const features = [
    {
      icon: <LocalGasStationIcon fontSize="large" color="secondary" />,
      title: t("fuelPolicy"),
      description: t("fuelPolicyDescription"),
    },
    {
      icon: <LocalShipping fontSize="large" color="secondary" />,
      title: t("pickUpDropOffFlexibility"),
      description: t("pickUpDropOffFlexibilityDescription"),
    },
    {
      icon: <AllInclusive fontSize="large" color="secondary" />,
      title: t("unlimitedKilometers"),
      description: t("unlimitedKilometersDescription"),
    },
    {
      icon: <TipsAndUpdates fontSize="large" color="secondary" />,
      title: t("tipsAndUpdates"),
      description: t("tipsAndUpdatesDescription"),
    },
    {
      icon: <GppGood fontSize="large" color="secondary" />,
      title: t("fullInsurance"),
      description: t("fullInsuranceDescription"),
    },
    {
      icon: <HeadsetMic fontSize="large" color="secondary" />,
      title: t("travelAssistance"),
      description: t("travelAssistanceDescription"),
    },
  ];

  return (
    <ThemeProvider theme={theme}>
      <Box py={6} px={2}>
        <Typography
          variant="h4"
          component="h2"
          sx={{ color: "primary.main", textAlign: "center", mb: 4 }}
        >
          {t("howItWorks")}
        </Typography>
        <Grid container spacing={2} justifyContent="center">
          {features.map((feature, index) => (
            <Grid key={index} item xs={12} sm={6} md={4}>
              <Paper sx={{ p: 3, borderRadius: 4, height: "100%" }}>
                <Box
                  display="flex"
                  flexDirection="column"
                  alignItems="center"
                  gap={2}
                >
                  {feature.icon}
                  <Typography
                    variant="subtitle1"
                    sx={{ fontWeight: "bold", textAlign: "center" }}
                  >
                    {feature.title}
                  </Typography>
                  <Typography variant="body2" sx={{ textAlign: "center" }}>
                    {feature.description}
                  </Typography>
                </Box>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Box>
    </ThemeProvider>
  );
};

export default Features;
